import { Grid, Tooltip, Typography } from '@mui/material';
import MFSelectField from '../../../lib/formik/SelectField';
import { ProceedSaveLater, SubHeading } from '../../investors/components';
import { MFTextField } from '../../../lib/formik';
import { Formik, validateYupSchema, yupToFormErrors } from 'formik';
import {
  Applicant,
  ApplicantAddressType,
  ContactPerson,
  DigilockerRecord,
  Fatcadetails,
  KraDocumentType,
} from '../../../redux-store/types/api-types';
import {
  grossAnnualMasters,
  investorTypeMasters,
  investorTypeOutboundMasters,
  PEPsMasters,
  SAVE_LATER_VALIDATION_CHECK,
  servicesMaster,
} from '../../../utils/constant';
import { DatePicker } from '../../../lib/formik/DatePicker';
import React, { useEffect, useState } from 'react';
import {
  applicationComparison,
  checkRelationshipWithPep,
  currencyConversion,
  getIsServiceRequired,
  getRelationshipWithPepLabel,
  getServicesUpdate,
  getStep,
  ifPushToXalt,
  IsInvestorWithPAN,
  IsOutBoundFundFlow,
  minNetworthDate,
  removeSingleQuote,
  saveForLater,
  statusRoleBased,
} from '../../../utils/utilityFunctions';
import { useHistory } from 'react-router';
import { useDispatch, useSelector } from 'react-redux';
import { RootStateType } from '../../../redux-store/reducers';
import { updateApplication } from '../../../redux-store/actions/application';
import { NonIndividualContributorValidationSchemaWithPan } from '../../../utils/schema';
import { useSnackbar } from 'notistack';
import FieldValidationNote from '../../investors/FieldValidationNote';
import { SearchableSelect } from '../../../lib/formik/searchSelectField';
import { mdmsCountriesList, nationaliyType } from '../../../redux-store/types/mdms';
import { getNationalityList } from '../../../redux-store/actions';
import MultiSelectCheckbox from '../../../lib/formik/MultiCheckbox';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';

export type _Applicant = Applicant & {
  otherNameOfBroker: string;
  isServicesRequired: string[];
  [key: string]:
    | string
    | null
    | number
    | undefined
    | boolean
    | Partial<ApplicantAddressType>[]
    | ContactPerson
    | KraDocumentType
    | Fatcadetails
    | (boolean | null)[]
    | string[]
    | DigilockerRecord;
};
const contributorObject: Partial<_Applicant> = {
  name: '',
  cityOfIncorporation: '',
  ckycNo: '',
  maskedCkycNo: '',
  investorType: '',
  dateOfBirth: '',
  panNo: '',
  grossAnnualIncome: '',
  kraVerified: '',
  amlCheck: false,
  netWorth: '',
  politicallyExposedPersonStatus: '',
  relationshipWithPep: '',
  dlclId: '',
  nameOfBroker: '',
  kraMobileNumber: '',
  kraEmailId: '',
  otherNameOfBroker: '',
  corporateIdentificationNo: '',
  lawType: '',
  countryOfIncorporation: '',
  netWorthDate: null,
  isServicesRequired: [],
  boiOrAop: '',
};

export type Values = {
  saveType: string;
  modeOfHolding: string;
  applicants: Partial<_Applicant>[];
  flowType: string;
  fundFlowType: string;
};

const initialValues: Values = {
  modeOfHolding: 'single',
  applicants: [contributorObject],
  saveType: 'save and proceed',
  flowType: '',
  fundFlowType: '',
};

export default function ContributorDetailsWithPan(): JSX.Element {
  const { application } = useSelector((store: RootStateType) => store.application);
  const [contributorValues, setContributorValues] = useState(initialValues);
  const history = useHistory();
  const dispatch = useDispatch();
  const { role = '' } = useSelector((store: RootStateType) => store.auth);
  const [loading, setLoading] = useState(false);
  const { enqueueSnackbar } = useSnackbar();
  const { flowType = '', fundFlowType = '' } = application || {};
  const [mdmsCountriesList, setMdmsCountriesList] = useState<mdmsCountriesList[]>([]);
  //   const [brokerList, setBrokerList] = useState<BrokerList>();

  useEffect(() => {
    (async function () {
      try {
        const nationalitiesMdmsMasters = (await dispatch(
          getNationalityList()
        )) as unknown as nationaliyType;
        const countryList = nationalitiesMdmsMasters.countries.concat(
          nationalitiesMdmsMasters.eddCountries
        );
        setMdmsCountriesList(countryList);
      } catch (e) {
        console.error((e as Error).message);
      }
    })();
  }, []);
  useEffect(() => {
    (async function () {
      try {
        // const response = (await dispatch(getBrokers())) as unknown as BrokerList;
        // setBrokerList(response as BrokerList);

        const { applicants = [] } = application || {};
        setContributorValues({
          ...contributorValues,
          applicants: applicants.length
            ? applicants.map((applicant) => {
                const isServicesRequired = getIsServiceRequired(applicant);
                return {
                  ...applicant,
                  amlCheck: (applicant.amlCheck ? 'Yes' : 'No') as any,
                  //   dlclId: applicant.dlclId ? applicant.dlclId : '',
                  //   nameOfBroker: nameOfBrokerExists(
                  //     response?.broker_list as Broker[],
                  //     applicant.nameOfBroker || ''
                  //   )
                  //     ? applicant.nameOfBroker
                  //     : applicant.nameOfBroker
                  //     ? 'others'
                  //     : '',
                  //   otherNameOfBroker: nameOfBrokerExists(
                  //     response?.broker_list as Broker[],
                  //     applicant.nameOfBroker || ''
                  //   )
                  //     ? ''
                  //     : applicant.nameOfBroker,
                  ckycNo: applicant.maskedCkycNo ? applicant.maskedCkycNo : applicant.ckycNo,
                  investorType: applicant.investorType || '',
                  lawType: applicant.lawType || '',
                  isServicesRequired: isServicesRequired,
                };
              })
            : ([contributorObject] as _Applicant[]),
          flowType: flowType,
          fundFlowType: fundFlowType,
        });
      } catch (e) {
        console.error((e as Error).message);
      }
    })();
  }, [application]);

  const handleApplicant = async (values: Values) => {
    const { saveType } = values;
    const {
      id,
      currentStep,
      banks = [],
      applicant1ReferenceId = '',
      applicationNumber,
    } = application || {};
    const checkApplication = applicationComparison(
      {
        ...application,
        applicants: application?.applicants
          .map((applicant) => ({
            ...applicant,
            name: removeSingleQuote(applicant.name),
            cityOfIncorporation: removeSingleQuote(applicant.cityOfIncorporation),
          }))
          ?.sort((applicant1, applicant2) => Number(applicant1.id) - Number(applicant2.id)),
      },
      {
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        ...application!,
        banks:
          values.applicants[0].name?.split("'").join('').trim() ===
          application?.applicants[0].name?.split("'").join('').trim()
            ? banks
            : banks.map((bank) => ({
                ...bank,
                pennydropCheck: false,
                pennydropVerified: false,
              })),
        applicants: values.applicants
          .map((applicant) => {
            const {
              otherNameOfBroker: othersNameOfBroker,
              isServicesRequired,
              ...rest
            } = applicant;
            return {
              ...application?.applicants[0],
              ...rest,
              name: removeSingleQuote(applicant.name),
              cityOfIncorporation: removeSingleQuote(applicant.cityOfIncorporation),
              boiOrAop:
                ifPushToXalt(application?.pushDataTo || '') &&
                investorTypeMasters[applicant?.investorType || ''] ===
                  investorTypeMasters.boi_or_aop
                  ? applicant.boiOrAop
                  : '',
              amlCheck: (applicant.amlCheck as any) === 'Yes' ? true : false,
              relationshipWithPep: checkRelationshipWithPep(
                applicant.politicallyExposedPersonStatus || ''
              )
                ? applicant.relationshipWithPep
                : null,
              ...getServicesUpdate(isServicesRequired || []),
              //   dpId: cleardpIdField(applicant.dlclId || '') ? '' : applicant?.dpId?.toUpperCase(),
              //   nameOfBroker: cleardpIdField(applicant.dlclId || '')
              //     ? ''
              //     : otherNameOfBroker(applicant.nameOfBroker || '')
              //     ? othersNameOfBroker?.toString()
              //     : applicant.nameOfBroker,
              netWorthDate: IsOutBoundFundFlow(fundFlowType)
                ? applicant.netWorthDate || null
                : null,
            };
          })
          .sort((applicant1, applicant2) => Number(applicant1.id) - Number(applicant2.id)),
        modeOfHolding: 'single',
        currentStep: !!currentStep && currentStep > 1 ? currentStep : Number(currentStep) + 1,
      }
    );

    const isSaveLater = saveType !== 'save and proceed';
    if (id && !checkApplication) {
      await dispatch(
        updateApplication({
          body: {
            ...application,
            banks:
              values.applicants[0].name?.split("'").join('').trim() ===
              application?.applicants[0].name?.split("'").join('').trim()
                ? banks
                : banks.map((bank) => ({
                    ...bank,
                    pennydropCheck: false,
                    pennydropVerified: false,
                  })),
            applicants: values.applicants.map((applicant) => {
              const {
                otherNameOfBroker: othersNameOfBroker,
                isServicesRequired,
                ...rest
              } = applicant;
              return {
                ...application?.applicants[0],
                ...rest,
                name: removeSingleQuote(applicant.name),
                cityOfIncorporation: removeSingleQuote(applicant.cityOfIncorporation),
                boiOrAop:
                  ifPushToXalt(application?.pushDataTo || '') &&
                  investorTypeMasters[applicant?.investorType || ''] ===
                    investorTypeMasters.boi_or_aop
                    ? applicant.boiOrAop
                    : '',
                countryOfIncorporation: applicant.countryOfIncorporation,
                amlCheck: (applicant.amlCheck as any) === 'Yes' ? true : false,
                relationshipWithPep: checkRelationshipWithPep(
                  applicant.politicallyExposedPersonStatus || ''
                )
                  ? applicant.relationshipWithPep
                  : null,
                ...getServicesUpdate(isServicesRequired || []),
                ckycNo: applicant.maskedCkycNo ? '' : applicant.ckycNo,
                // clId: clearclIdField(applicant.dlclId || '') ? '' : applicant.clId,
                // dpId: cleardpIdField(applicant.dlclId || '') ? '' : applicant?.dpId?.toUpperCase(),
                // nameOfBroker: cleardpIdField(applicant.dlclId || '')
                //   ? ''
                //   : otherNameOfBroker(applicant.nameOfBroker || '')
                //   ? othersNameOfBroker?.toString()
                //   : applicant.nameOfBroker,
                netWorthDate: IsOutBoundFundFlow(fundFlowType)
                  ? applicant.netWorthDate || null
                  : null,
              };
            }),
            modeOfHolding: 'single',
            status: statusRoleBased(role, application),
            currentStep: getStep(2, isSaveLater),
            ...((!SAVE_LATER_VALIDATION_CHECK as boolean) && { saveForLater: isSaveLater }),
          },
          applicationId: id,
          ...(saveType !== 'save and proceed' && {
            toastMessage: '',
          }),
          flowType,
        })
      );
      saveType === 'save and proceed'
        ? history.push('contact-details', { id, applicant1ReferenceId })
        : history.push(saveForLater(role, id, applicant1ReferenceId));
    } else if (checkApplication) {
      if (saveType !== 'save and proceed') {
        enqueueSnackbar(`Application ${applicationNumber} - ` + ' Saved successfully', {
          variant: 'success',
          autoHideDuration: 3000,
        });
      }
      saveType === 'save and proceed'
        ? history.push('contact-details', { id, applicant1ReferenceId })
        : history.push(saveForLater(role, id, applicant1ReferenceId));
    }
  };

  const handleSubmit = async (values: Values) => {
    try {
      setLoading(true);
      await handleApplicant(values);
      setLoading(false);
    } catch (e) {
      setLoading(false);
      console.error((e as Error).message);
    }
  };

  return (
    <Formik
      initialValues={contributorValues}
      validate={(values: Values) => {
        try {
          validateYupSchema(
            values,
            NonIndividualContributorValidationSchemaWithPan(
              application?.createdAt || '',
              ifPushToXalt(application?.pushDataTo || '')
            ),
            true,
            values
          );
        } catch (e) {
          return yupToFormErrors(e);
        }
      }}
      onSubmit={handleSubmit}
      enableReinitialize={true}>
      {({ handleSubmit, values, setValues }) => (
        <>
          <Grid
            container
            rowSpacing={1}
            sx={{
              width: '100%',
              ml: 0,
              '.MuiGrid-item': { px: { xs: 0, sm: '30px' } },
            }}
            component="form"
            noValidate
            onSubmit={handleSubmit}>
            {values.applicants.map((applicant, index) => (
              <React.Fragment key={index}>
                <Grid item xs={12} sm={6}>
                  <MFTextField
                    name={`applicants.${index}.name`}
                    label="Name of Entity *"
                    placeholder="Enter Name of Entity"
                    disabled={applicant.dataFetchedFromKRA || false}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <DatePicker
                    label={'Date of Registration/Incorporation *'}
                    inputLabelStyles={{
                      transform: 'unset',
                      fontSize: 14,
                      fontWeight: 500,
                      color: 'rgba(0,0,0,0.7)',
                    }}
                    placeholder={'DD/MM/YYYY'}
                    name={`applicants.${index}.dateOfBirth`}
                    disabled={applicant.dataFetchedFromKRA || false}
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <MFTextField
                    name={`applicants.${index}.cityOfIncorporation`}
                    label="Place of Registration/Incorporation *"
                    placeholder="Enter Place of Registration/Incorporation"
                  />
                </Grid>
                {IsOutBoundFundFlow(fundFlowType) && (
                  <Grid item xs={12} sm={6}>
                    <SearchableSelect
                      name={`applicants.${index}.countryOfIncorporation`}
                      label="Country Of Incorporation *"
                      items={mdmsCountriesList.map((nationality) => ({
                        key: nationality?.name,
                        value: nationality?.name,
                      }))}
                      searchFieldPlaceholder={'Search Country Of Incorporation'}
                    />
                  </Grid>
                )}
                <Grid item xs={12} sm={6}>
                  <MFTextField
                    name={`applicants.${index}.corporateIdentificationNo`}
                    label="Corporate Identification number (if applicable)"
                    placeholder="Enter Corporate Identification number (if applicable)"
                  />
                </Grid>

                <Grid item xs={12} sm={6}>
                  <div
                    style={{
                      display: 'flex',
                      flexDirection: 'row',
                      alignItems: 'center',
                      gap: '8px',
                    }}>
                    <MFTextField
                      name={`applicants.${index}.ckycNo`}
                      label="CKYC No./CKYC Acknowledge No./KIN No "
                      placeholder="Enter CKYC No./CKYC Acknowledge No./KIN No"
                      disabled={!!applicant.maskedCkycNo || false}
                    />
                    <Tooltip title="Please add a valid ckyc either last 4 digits or full 14 digit number">
                      <InfoOutlinedIcon />
                    </Tooltip>
                  </div>
                </Grid>
                {/* <Grid item xs={12} sm={6}>
                  <MFTextField
                    name={`applicants.${index}.kraVerified`}
                    label="CVL KRA Verified"
                    placeholder="Enter CVL KRA Verified"
                    sx={{
                      '& .MuiInputBase-input': {
                        textTransform: 'capitalize',
                      },
                    }}
                    disabled={true}
                  />
                </Grid> */}
                <Grid item xs={12} sm={6}>
                  <MFTextField
                    name={`applicants.${index}.amlCheck`}
                    label="AML Verified"
                    placeholder="Enter AML Verified"
                    disabled={true}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <MFSelectField
                    name={`applicants.${index}.investorType`}
                    label="Investor Type *"
                    items={Object.keys(
                      IsOutBoundFundFlow(fundFlowType)
                        ? investorTypeOutboundMasters
                        : investorTypeMasters
                    ).map((investor) => ({
                      key: (IsOutBoundFundFlow(fundFlowType)
                        ? investorTypeOutboundMasters
                        : investorTypeMasters)[investor],
                      value: investor,
                    }))}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <MFTextField
                    name={`applicants.${index}.panNo`}
                    label="PAN *"
                    placeholder="Enter PAN"
                    disabled={true}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <MFTextField
                    name={`applicants.${index}.lawType`}
                    label="Law under which formed/incorporated *"
                    placeholder="Enter Law under which formed/incorporated"
                    // disabled={true}
                  />
                </Grid>
                {applicant.kraMobileNumber && (
                  <Grid item xs={12} sm={6}>
                    <MFTextField
                      name={`applicants.${index}.kraMobileNumber`}
                      label={`KRA Mobile Number`}
                      placeholder="Enter KRA Mobile Number"
                      disabled={true}
                    />
                  </Grid>
                )}
                {applicant.kraEmailId && (
                  <Grid item xs={12} sm={6}>
                    <MFTextField
                      name={`applicants.${index}.kraEmailId`}
                      label={`KRA Email Id`}
                      placeholder="Enter KRA Email Id"
                      disabled={true}
                    />
                  </Grid>
                )}
                <SubHeading
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                  }}>
                  Other Details
                </SubHeading>
                <Grid item xs={12} sm={6}>
                  <MFSelectField
                    name={`applicants.${index}.grossAnnualIncome`}
                    label="Gross Annual Income in USD *"
                    items={grossAnnualMasters['foreign'].map((grossIncome) => ({
                      key: grossIncome,
                      value: grossIncome,
                    }))}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <MFTextField
                    name={`applicants.${index}.netWorth`}
                    label={`Net Worth${IsOutBoundFundFlow(fundFlowType) ? '' : ' *'}`}
                    placeholder="Enter Net Worth"
                  />
                  {values.applicants[index].netWorth &&
                    !isNaN(Number(values.applicants[index].netWorth)) && (
                      <Typography sx={{ fontSize: 13 }}>
                        {currencyConversion(values.applicants[index].netWorth, 'usd')}
                      </Typography>
                    )}
                </Grid>
                {IsOutBoundFundFlow(fundFlowType) && (
                  <Grid item xs={12} sm={6}>
                    <DatePicker
                      label={'Net worth as on'}
                      inputLabelStyles={{
                        transform: 'unset',
                        fontSize: 14,
                        fontWeight: 500,
                        color: 'rgba(0,0,0,0.7)',
                      }}
                      placeholder={'Enter Net worth as on'}
                      name={`applicants.${index}.netWorthDate`}
                      minDate={minNetworthDate(application?.createdAt || '')}
                    />
                  </Grid>
                )}
                <Grid item xs={12} sm={6}>
                  <MFSelectField
                    name={`applicants.${index}.politicallyExposedPersonStatus`}
                    label="Politically Exposed Person (PEP) Status *"
                    items={PEPsMasters.map((pep) => ({ key: pep, value: pep }))}
                  />
                </Grid>
                {checkRelationshipWithPep(applicant.politicallyExposedPersonStatus || '') && (
                  <Grid item xs={12} sm={6}>
                    <MFTextField
                      name={`applicants.${index}.relationshipWithPep`}
                      label={`${getRelationshipWithPepLabel(
                        applicant.politicallyExposedPersonStatus || ''
                      )} *`}
                      placeholder={`Enter ${getRelationshipWithPepLabel(
                        applicant.politicallyExposedPersonStatus || ''
                      ).toLowerCase()}`}
                    />
                  </Grid>
                )}
                {/* <Grid item xs={12} sm={6}>
                  <MFSelectField
                    name={`applicants.${index}.dlclId`}
                    label="Demat Account Details (for allotment of units) *"
                    items={Object.keys(DLCLMasters).map((Id) => ({
                      key: DLCLMasters[Id],
                      value: Id,
                    }))}
                  />
                </Grid>
                {getdpIdField(values.applicants[index].dlclId || '') && (
                  <Grid item xs={12} sm={6}>
                    <MFTextField
                      name={`applicants.${index}.dpId`}
                      label={`${
                        isCDSL(values.applicants[index].dlclId || '') ? 'DPCL ID' : 'DP ID'
                      } *`}
                      placeholder={`Enter ${
                        isCDSL(values.applicants[index].dlclId || '') ? 'DPCL ID' : 'DP ID'
                      }`}
                      inputProps={{ style: { textTransform: 'uppercase' } }}
                    />
                  </Grid>
                )}
                {getclIdField(values.applicants[index].dlclId || '') && (
                  <Grid item xs={12} sm={6}>
                    <MFTextField
                      name={`applicants.${index}.clId`}
                      label="CL ID *"
                      placeholder="Enter CL ID"
                    />
                  </Grid>
                )}
                {getdpIdField(values.applicants[index].dlclId || '') && (
                  <Grid item xs={12} sm={6}>
                    <SearchableSelect
                      name={`applicants.${index}.nameOfBroker`}
                      label="Name of Broker/Depository Participant (DP)"
                      items={sortListKeepOthersLast(brokerList?.broker_list as Broker[])?.map(
                        (broker: Broker) => ({
                          key: broker.value,
                          value: broker.key,
                        })
                      )}
                      searchFieldPlaceholder={'Search Broker/Depository Participant'}
                    />
                  </Grid>
                )}
                {getdpIdField(values.applicants[index].dlclId || '') &&
                  otherNameOfBroker(values.applicants[index].nameOfBroker || '') && (
                    <Grid item xs={12} sm={6}>
                      <MFTextField
                        name={`applicants.${index}.otherNameOfBroker`}
                        label="Name of Broker *"
                        placeholder="Enter Name of Broker"
                      />
                    </Grid>
                  )} */}
                {IsOutBoundFundFlow(fundFlowType) && (
                  <Grid item xs={12} sm={12}>
                    <MultiSelectCheckbox
                      options={Object.keys(servicesMaster).map((option) => ({
                        key: option,
                        value: servicesMaster[option],
                      }))}
                      name={`applicants.${index}.isServicesRequired`}
                      formLabel="Non-Individual investors involved/providing any of the mentioned services:"
                      selectedValues={values.applicants[index].isServicesRequired as string[]}
                    />
                  </Grid>
                )}
              </React.Fragment>
            ))}
            <FieldValidationNote />
            <ProceedSaveLater
              saveLater={() => {
                setValues({
                  ...values,
                  applicants: values.applicants.map((applicant) => ({
                    ...applicant,
                  })),
                  saveType: 'save for later',
                });
              }}
              saveAndProceed={() => {
                setValues({
                  ...values,
                  applicants: values.applicants.map((applicant) => ({
                    ...applicant,
                  })),
                  saveType: 'save and proceed',
                });
              }}
              loader={loading}
              clickedButton={values.saveType}
            />
          </Grid>
        </>
      )}
    </Formik>
  );
}
